import {Component, ElementRef, HostBinding, inject, Input, NgZone, OnDestroy, OnInit,} from '@angular/core';
import { LMBuilderModel } from "@components/builder/services/lm-builder-model.service";
import { LMContextService } from "@app/services";
import { CdkDrag, CdkDragDrop, CdkDropList } from "@angular/cdk/drag-drop";

@Component({
  selector:    'lm-builder-preview',
  standalone: false,
  templateUrl: './lm-builder-preview.component.html',
  styleUrl: './lm-builder-preview.component.scss',
})
export class LMBuilderPreviewComponent implements OnInit  {
  @Input() spec!: LMListPSpec;
  @Input() lpl = '';
  @Input() userFolderJson = '';
  @Input() listSpec: LMListSpec | undefined;
  @Input() listUrlInfo: LMListUrlInfo | undefined;
  @Input() listTitleOverride: string | undefined;

  protected readonly LMBuilderModel = LMBuilderModel;

  displayOption = 'list';
  titleRequired = false;
  title = '';
  showDebug = false;

  constructor(
      private lmBuilderModel: LMBuilderModel,
      private lmContextService: LMContextService,
  ) {
    // no-op
  }

  ngOnInit(): void {
    this.showDebug = this.lmContextService.isDeveloper();
    this.initialize();
  }

  private initialize() {
    if (this.spec?.userFolder) {
      this.title = this.spec.userFolder.name;
    } else {
      this.title = this.spec.titleIs.fields ? this.spec.titleIs.messageRule : this.spec.titleIs.display;
    }
    // @ts-ignore
    Soho.Validation.rules['validateTitle'] = this.lmBuilderModel.validateTitle();
  }

  updateTitle() {
    this.lmBuilderModel.updateTitle(this.title);
  }

  canDrop = (drag: CdkDrag, drop: CdkDropList): boolean => {
    if (drag.dropContainer.data.includes('lm-builder-field')) {
      return this.lmBuilderModel.allowColumnField(drag.data);
    } else if (drag.dropContainer.data.includes(LMBuilderModel.DISPLAY_FIELDS_LIST)) {
      return true;
    }

    return false;
  };

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer.data.includes('lm-builder-field')) {
      if (this.lmBuilderModel.allowColumnField(event.item.data)) {
        this.lmBuilderModel.addDisplayField(event.currentIndex, event.item.data);
      }
    } else if (event.previousContainer.data.includes(LMBuilderModel.DISPLAY_FIELDS_LIST)) {
      this.lmBuilderModel.reorderDisplayField(event.currentIndex, event.previousIndex, event.item.data);
    }
  }
}